import { css } from 'styled-components';
import { shorthand } from './common.mjs';

var bordersTemplate = function bordersTemplate(border) {
  var _border$left, _border$left2, _border$right, _border$right2;
  if (!border) {
    return css({});
  }
  switch (border.type) {
    case 'border':
      return css({
        border: shorthand(border),
        borderRadius: border.radius
      });
    case 'bordergroup':
      return css({
        borderBottom: shorthand(border.bottom),
        borderTop: shorthand(border.top),
        borderLeft: shorthand(border.left),
        borderRight: shorthand(border.right),
        borderBottomLeftRadius: border === null || border === void 0 ? void 0 : (_border$left = border.left) === null || _border$left === void 0 ? void 0 : _border$left.radius,
        borderTopLeftRadius: border === null || border === void 0 ? void 0 : (_border$left2 = border.left) === null || _border$left2 === void 0 ? void 0 : _border$left2.radius,
        borderBottomRightRadius: border === null || border === void 0 ? void 0 : (_border$right = border.right) === null || _border$right === void 0 ? void 0 : _border$right.radius,
        borderTopRightRadius: border === null || border === void 0 ? void 0 : (_border$right2 = border.right) === null || _border$right2 === void 0 ? void 0 : _border$right2.radius
      });
    default:
      return css({});
  }
};

export { bordersTemplate };
